export default __webpack_public_path__ + "static/boge-highlighted-image-dbc6de6a4786bc6f0ca729edddda6802.png";